module.exports = __webpack_public_path__ + "static/img/carrot.c40a6a9d.webp";